<!-- header part start-->
<div class="container-fluid" style="padding: 0px 5px;">
  <div style=" display: inline;block-size: 10%;">
    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 10px;">
        <div class="col-md-6 col-sm-6" style="display: inline-block; padding-left: 6px; ">
            <h2 class="ng-binding header lblHeader newHeader" style="font-size: 25px;">
              Consolidated Stock Transactions
            </h2>
        </div>
        <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px;text-align: right; padding-right: 5px;padding-top: 10px;">
          <span class="search">
            <span class="fa fa-search" style="padding-left: 13px; font-size: 14px;
            position: absolute;top: 19px;color: #999;"></span>
              <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
              (keyup)="applyFilter($event)" #input
              style="text-align: left; background-color: white; display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 45% !important; height: 31px !important;"
              type="text">
 
          </span>
          <span (click)="exportToExcelActivities()" class="orangeButton"
            style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
            <span>
              <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
            </span>
          </span>
  
            <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
                <span class="darkBlueButton"
                    style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
                    (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>

        </div>
    </div>
</div>
<!-- filter -->
<div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 0px;">
<div class="col-md-8 col-sm-8" style="display: inline-block;padding-left: 0px; ">
<div class="col-md-12 col-12 col-sm-12"style="display: inline-block;padding-left: 11px;  " >
  
    <span class="label custom-margin-btn bz-orgBtn-lb btnPad fntSz {{period == 1 ? 'bz-orgBtn-lb-active' : ''}}" (click)="typeFilter(1)"style="cursor: pointer; margin-left: 8px;"><span>This Month</span></span>
    <span class="label custom-margin-btn bz-orgBtn-lb btnPad fntSz {{period == 2 ? 'bz-orgBtn-lb-active' : ''}}" (click)="typeFilter(2)"style="cursor: pointer; margin-left: 8px;"><span>Last Month</span></span>
    <span class="label custom-margin-btn bz-orgBtn-lb btnPad fntSz {{period == 3 ? 'bz-orgBtn-lb-active' : ''}}" (click)="typeFilter(3)"style="cursor: pointer; margin-left: 8px;padding-top: 5px;"> <span>Fin Year</span></span>
    
    <div *ngIf="period == 3"  style="display:inline-block ;">
      <div style="display: inline-block;margin-left: 10px;">
        <select class="form-control  formCtlFltr bgwhite" [(ngModel)]="view.fy" (ngModelChange)="ddlchangeYear()"
        style="display: inline-block; padding: 1px 3px; font-size: 13px; width: 110px; margin-right: 4px;">
        <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
        <!-- <option value="Other">Other</option> -->
    </select>
  
      </div>
    </div>
    <!-- <span class="label custom-margin-btn teal-Badge fntSz {{period == 4 ? 'teal-Badge-active' : ''}}"(click)="typeFilter(4)" style="cursor: pointer; margin-left: 8px;"><span>Last Fin Yr</span></span> -->
    <span class="label custom-margin-btn margin-btn bz-orgBtn-lb btnPad fntSz {{period == 5 ? 'bz-orgBtn-lb-active' : ''}} " id="other" style="cursor: pointer; margin-left: 7px;" (click)="typeFilter(5)">Other</span>
    
    
      
  <div *ngIf="period == 5"  style="display:inline-block ;">
    <div style="display: inline-block; padding-left: 8px;" >
        <label  style="font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
            for="sel1">Month : </label>
    </div>

    <div style="display: inline-block;margin-left: 10px;">
        <select  class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 100px;cursor: pointer; font-size: 13px;" [(ngModel)]="monthDisplay" 
        (change) ="trasYearChange()">
        <!-- <option [value]="i.number" *ngFor="let i of months;"  >{{i.display}}</option> -->
        <option *ngFor="let i of months;">{{i.display}}</option>
      </select>
    </div>
  </div>
</div>

</div>
<div class="col-md-4 col-sm-4" style="display: inline-block;padding-left: 5px;text-align: right; padding-top: 2px;">
<span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{periodtrans == 3? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="typeFilterTrans(3)" style="cursor: pointer; margin-left: 8px;"> <span>Internal</span></span>
<span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{periodtrans == 2 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="typeFilterTrans(2)" style="cursor: pointer; margin-left: 8px;"> <span>External</span></span>
<span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{periodtrans == 1 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="typeFilterTrans(1)" style="cursor: pointer; margin-left: 8px;"><span>All Transactions</span></span>
</div>
</div>

<!-- close filter -->
    <div class="wrapper" style="overflow: hidden; padding-left: 0px !important; text-overflow: ellipsis; white-space: nowrap; padding-top: 5px; padding-right: 14px;border-radius: 3px;" *ngIf="dataSource.data.length > 0" #csttable>
      <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
       
        <ng-container matColumnDef="ItemName">
          <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
            <label style="font-size: 13px;">Item</label>
          </th>
          <td mat-cell *matCellDef="let element" style="padding-right: 52px ! important;"> {{element.ItemName}} </td>

          <!-- <td mat-cell *matCellDef="let element" style="padding-right: 52px ! important;"> {{element.item}} </td> -->
        </ng-container>
    
        <ng-container matColumnDef="categoryName">
          <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
            <label style="font-size: 13px; width: 10%;">  Category</label>
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left; padding-right: 52px !important;vertical-align: middle;"  > {{element.categoryName}}  </td>
        </ng-container>

        <ng-container matColumnDef="subCategoryName">
          <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 7px;">
            <label style="font-size: 13px; width: 10%;">  Sub-category</label>
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left;vertical-align: middle;" > {{element.subCategoryName}}  </td>
        </ng-container>

        <!-- <ng-container matColumnDef="DispatchQty">
          <th [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 20px; text-align: right; padding-left: 4%;" >
            <label style="font-size: 13px;padding-right: 6px;">Dispatch</label>
          </th>
          <td [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element" style="text-align: right;vertical-align: middle;" > {{element.DispatchQty}}  </td>
        </ng-container> -->
        <ng-container matColumnDef="DispatchQty">
          <th [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
              style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; width: 6%;">
              <label style="cursor: pointer;font-size: 13px;">Dispatch</label>
             
          </th>
          <td [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element">
              <div style="text-align: right; padding-right: 11px;">
                {{element.DispatchQty }} </div>
          </td>
      </ng-container>
        
        <!-- <ng-container matColumnDef="consumption" >
          <th [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'"  class="header header-Table fntSz"  mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 20px;text-align: right;padding-left: 2%;">
            <label style="font-size: 13px;padding-right: 6px;">Consumption</label>
          </th>
          <td [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'"  mat-cell *matCellDef="let element" style="text-align: right;vertical-align: middle;" > {{element.consumption }}  </td>
        </ng-container> -->
        <ng-container matColumnDef="consumption">
          <th [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
              style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 5px; width: 6%;">
              <label style="cursor: pointer;font-size: 13px;">Consumption</label>
             
          </th>
          <td [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element">
              <div style="text-align: right; padding-right: 11px;">
                {{element.consumption }}</div>
          </td>
      </ng-container>


        <!-- <ng-container matColumnDef="ProductionQty">
          <th [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'"class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 20px;text-align: right;padding-left: 5%; ">
            <label style="font-size: 13px;padding-right: 6px;">Production</label>
          </th>
          <td  [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'"mat-cell *matCellDef="let element" style="text-align: right;vertical-align: middle;" > {{element.ProductionQty }}  </td>
        </ng-container> -->
        <ng-container matColumnDef="ProductionQty">
          <th [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
              style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; width: 5%;">
              <label style="cursor: pointer;font-size: 13px;">Production</label>
             
          </th>
          <td [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element">
              <div style="text-align: right; padding-right: 11px;">
                {{element.ProductionQty }} </div>
          </td>
      </ng-container>

        <!-- <ng-container matColumnDef="InwardQty">
          <th [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 20px;text-align: right;padding-left: 5%;">
            <label style="font-size: 13px; padding-right: 8px;">Inward</label>
          </th>
          <td [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element" style="text-align: right;vertical-align: middle;" > {{element.InwardQty }}  </td>
        </ng-container> -->

        <ng-container matColumnDef="InwardQty">
          <th [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
              style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 27px; width: 5%;">
              <label style="cursor: pointer;font-size: 13px;">Inward</label>
             
          </th>
          <td [style.display]="(periodtrans == 2 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element">
              <div style="text-align: right; padding-right: 11px;">
                {{element.InwardQty }} </div>
          </td>
      </ng-container>

        <!-- <ng-container matColumnDef="ReconciliationInQty">
          <th [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 20px;text-align: right;padding-left: 5%;">
            <label style="font-size: 13px; padding-right: 6px;">Reconciliation</label>
          </th>
          <td [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element" style="text-align: right;vertical-align: middle;" > {{element.ReconciliationInQty }}  </td>
        </ng-container> -->
        <ng-container matColumnDef="ReconciliationQty">
          <th [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
              style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; width: 7%;">
              <label style="cursor: pointer;font-size: 13px;">Reconciliation</label>
             
          </th>
          <td [style.display]="(periodtrans == 3 || periodtrans == 1) ? '' : 'none'" mat-cell *matCellDef="let element">
              <div style="text-align: right; padding-right: 11px;">
                {{element.ReconciliationQty }} </div>
          </td>
      </ng-container>

        <ng-container matColumnDef="Unit">
          <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 2px;">
            <label style="font-size: 13px; padding-right: 4px;">Unit</label>
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left;vertical-align: middle;" > {{element.Unit }}  </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
     <!-- Angular 8 pagination -->
     <mat-paginator
          [pageSizeOptions]="[10, 15]" showFirstLastButtons>
     </mat-paginator>
  </div>
  <div *ngIf="dataSource.data.length == 0">
    <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
  </div>
  
</div>
